/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoldAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.75 2.75H14a5.25 5.25 0 0 1 3.838 8.832A5.25 5.25 0 0 1 15 21.25H4.75zm2.5 10.5v5.5H15a2.75 2.75 0 1 0 0-5.5zm0-2.5H14a2.75 2.75 0 1 0 0-5.5H7.25z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBoldAlt as BoldAlt };
